import applePay from '@services/apple-pay'
import googlePay from '@services/google-pay'

import storage from '@utils/storage'
import cookies from '@utils/cookies'

const STORAGE_PAYMENT_SETTINGS = 'da.donation.paymentSettings'

export const state = {
  paymentMethods: {},
  paymentMethod: _.get(storage.getItem(STORAGE_PAYMENT_SETTINGS), 'paymentMethod', null),
  paymentRegions: {},
  paymentRegion: _.get(storage.getItem(STORAGE_PAYMENT_SETTINGS), 'paymentRegion', false),

  paymentClientId: null,
  paymentSignature: null,

  paymentCredentials: {
    clientId: null,
    signature: null,
    data: null,
  },

  paymentData: {
    userId: null,
    currency: null,
    amount: null,
    type: null,
  },

  finalAmount: null,
}

export const getters = {
  getField,

  getPaymentMethod: state => code => state.paymentMethods[code],

  selectedPaymentMethod: (state, getters) => getters.getPaymentMethod(state.paymentMethod),

  paymentMethodsList: state => _.sortBy(Object.values(state.paymentMethods), 'order'),

  paymentRegionsList: state => Object.values(state.paymentRegions),
}

export const mutations = {
  updateField,

  SET_PAYMENT_CREDENTIALS(state, { clientId, signature, data }) {
    state.paymentCredentials = { clientId, signature, data }
  },

  SET_PAYMENT_DATA(state, { currency, amount, userId, type }) {
    state.paymentData = { currency, amount, userId, type }
  },

  SET_PAYMENT_METHODS(state, methods) {
    state.paymentMethods = _.keyBy(methods, 'code')
  },

  SET_PAYMENT_METHOD(state, method) {
    state.paymentMethod = method
  },

  SAVE_PAYMENT_SETTINGS(state) {
    storage.setItem(STORAGE_PAYMENT_SETTINGS, {
      paymentMethod: state.paymentMethod,
      paymentRegion: state.paymentRegion,
    })
  },

  SET_PAYMENT_REGIONS(state, regions) {
    state.paymentRegions = _.keyBy(regions, 'code')
  },
}

export const actions = {
  setPaymentData({ commit, rootGetters }, data) {
    const { user_id: userId, currency, amount, type } = data

    if (!_.map(rootGetters['currencies/payInCurrenciesList'], 'code').includes(currency)) {
      return Promise.reject('Wrong currency')
    }

    return commit('SET_PAYMENT_DATA', { currency, amount, userId, type })
  },

  fetchPaymentMethods({ commit, state }) {
    return api
      .get('/payin/systems', {
        user_id: state.paymentData.userId,
        group: true,
        currency: state.paymentData.currency,
        amount: state.paymentData.amount,
        apply_region_restrictions: true,
      })
      .then(({ data }) => {
        const restrictedMethods = []

        if (applePay.available) {
          if (_.map(data, 'key').includes('applePay')) {
            commit('SET_PAYMENT_METHOD', 'applePay')
          }
        } else {
          restrictedMethods.push('applePay')
        }

        if (!googlePay.available) {
          restrictedMethods.push('googlePay')
        }

        commit('SET_PAYMENT_METHODS', Object.values(data)
          .filter(method => !restrictedMethods.includes(method.key))
          .map((method, index) => ({
            code: method.key,
            title: method.title,
            group: method.group,
            order: {
              primary: 100,
              secondary: 200,
            }[method.group] + index,
            additional: method.addition,
          })))

        if (!state.paymentMethods[state.paymentMethod]) {
          commit('SET_PAYMENT_METHOD', null)
        }
      })
  },

  fetchPaymentRegions({ commit }, types = []) {
    return api.get('/region', { types })
      .then(({ data }) => {
        return commit('SET_PAYMENT_REGIONS', data.map(region => ({
          code: region.alpha2,
          name: region.name,
        })))
      })
  },

  fetchFinalAmount({ state, rootGetters }) {
    const payload = {
      currency: state.paymentData.currency,
      amount: state.paymentData.amount,
      system: state.paymentMethod,
      commission_covered: false,
      user_id: state.paymentData.userId,
      type: 'third_party_donation',
    }

    return api
      .get('/payin/get_final_amount', payload)
      .then(({ data }) => ({
        amount: data.amount,
        currencyCode: data.currency_code,
      }))
  },
}
